import { useQuery } from '@tanstack/react-query';
import { Collection } from '../../../api/collections';
import shopifyProductPageApiClient from '../../../api/shopifyProductPage';

const createPreviewCacheKey = (collection: Partial<Collection> | undefined) => {
  if (!collection) return null;

  const relevantFields = {
    name: collection.name,
    coverUrl: collection.coverUrl,
    logoUrl: collection.logoUrl,
    klydoIds: collection.klydoIds,
    description: collection.description,
    logoTypeUrl: collection.productPageMetadata?.logoTypeUrl,
    thumbnailBackgroundUrl:
      collection.productPageMetadata?.thumbnailBackgroundUrl,
    badgeColorHex: collection.productPageMetadata?.badgeColorHex,
    labels: collection.productPageMetadata?.labels,
    thumbnailKlydos: collection.productPageMetadata?.thumbnailKlydos,
    mockTemplateId: collection.productPageMetadata?.mockTemplateId,
    credits: collection.productPageMetadata?.credits,
  };

  return JSON.stringify(relevantFields);
};

export const useShopifyPreviewUrlQuery = (
  collectionId: string | undefined,
  collection?: Partial<Collection>,
) => {
  const cacheKey = createPreviewCacheKey(collection);

  return useQuery({
    queryKey: ['collection-shopify-preview-url', collectionId, cacheKey],
    queryFn: () =>
      shopifyProductPageApiClient.getCollectionShopifyPreviewUrl(collectionId!),
    enabled: false,
    staleTime: Infinity,
  });
};
